import React from "react"

import { ProductInformation } from "shared/types/__generated__/graphql"

import { ProductConfigurationAttributesContent } from "./ProductConfigurationAttributesContent"
import { ProductConfigurationAttributesContext } from "./ProductConfigurationAttributesContext"
import { ProductConfigurationCopyToClipboard } from "./ProductConfigurationCopyToClipboard"
import { useProductConfigurationAttributesClipboard } from "./model/useProductConfigurationAttributesClipboard"
import "./styles/_product-configuration-attributes.scss"

interface ProductConfigurationAttributesProps {
  productInformation: ProductInformation | null | undefined
  isLoading?: boolean
  children?: React.ReactNode
}

const ProductConfigurationAttributesRoot = React.memo(
  ({
    productInformation,
    isLoading,
    children
  }: ProductConfigurationAttributesProps) => {
    const { copyToClipboard } =
      useProductConfigurationAttributesClipboard(productInformation)

    const contextValue = React.useMemo(
      () => ({
        productInformation,
        isLoading,
        copyToClipboard
      }),
      [productInformation, isLoading, copyToClipboard]
    )

    if (!isLoading && !productInformation?.attributes?.length) {
      return null
    }

    return (
      <ProductConfigurationAttributesContext.Provider value={contextValue}>
        {children}
      </ProductConfigurationAttributesContext.Provider>
    )
  }
)

export const ProductConfigurationAttributes = Object.assign(
  ProductConfigurationAttributesRoot,
  {
    Root: ProductConfigurationAttributesRoot,
    CopyToClipboard: ProductConfigurationCopyToClipboard,
    Content: ProductConfigurationAttributesContent
  }
)
